import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

// The Admin Emails tab is gone: it held one read-only list of admin accounts and
// nothing else, so it now sits as a card on Distribution & Venues beside the
// other people lists. /admin/admin-emails redirects there — see App.js.
const ALL_TABS = [
  { label: 'Events',                path: '/admin/events'            },
  { label: 'Performers',            path: '/admin'                   },
  { label: 'Distribution & Venues', path: '/admin/distribution-list' },
  { label: 'Settings',              path: '/admin/settings'          },
  { label: 'Email',                 path: '/admin/email-templates'   },
];

const BOOKING_MANAGER_TABS = [
  { label: 'Events',     path: '/admin/events'  },
  { label: 'Performers', path: '/admin'         },
];

export default function AdminTabBar() {
  const location = useLocation();
  const navigate = useNavigate();

  const user = (() => {
    try { return JSON.parse(localStorage.getItem('user') || '{}'); }
    catch { return {}; }
  })();

  const tabs = user.role === 'booking_manager' ? BOOKING_MANAGER_TABS : ALL_TABS;

  return (
    <div style={{
      background: '#fff',
      borderBottom: '1px solid #e5e7eb',
      display: 'flex',
      padding: '0.3rem 1.5rem',
      gap: '0.25rem',
    }}>
      {tabs.map(tab => {
        const active = tab.path === '/admin'
          ? location.pathname === '/admin'
          : location.pathname.startsWith(tab.path);
        return (
          <button
            key={tab.path}
            onClick={() => navigate(tab.path)}
            style={{
              padding: '0.45rem 1rem',
              border: 'none',
              borderRadius: '7px',
              background: active ? '#1a1a2e' : 'transparent',
              cursor: 'pointer',
              fontWeight: 500,
              fontSize: '14px',
              color: active ? '#fff' : '#6b7280',
              transition: 'background 0.12s, color 0.12s',
              whiteSpace: 'nowrap',
            }}
          >
            {tab.label}
          </button>
        );
      })}
    </div>
  );
}
